import { apiV1Url } from '@/utils/apiBase'

/**
 * Cookie-based token refresh — bypasses axios interceptors to avoid 401 loop.
 */
export async function refreshSessionCookies(): Promise<void> {
  const url = apiV1Url('/auth/refresh')
  const res = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  })

  if (!res.ok) {
    throw new Error('Refresh failed')
  }
}
